export default __webpack_public_path__ + "static/silveroute-balthazaurus-scroll-c3958816e1e40d7db000e287725703d5.gif";